import { ASSET_DESKTOP, ASSET_MOBILE } from '../elements/assets'

export const SCROLL_SHOWCASE = `
...on scrollShowcase_Entry {
  id
  typeHandle
  anchorId

  heading: headingAdvanced {
    html
  }

  headingTextTable {
    heading
    text
  }

  items: scrollStoryItems {
    id
    title
    description

    ${ ASSET_DESKTOP }
    ${ ASSET_MOBILE }

  }
  
}
`